import { object, record, string, TypeOf } from 'zod';

/* ----------------------------- BaseDictionary ----------------------------- */

export const BaseDictionary = object({
    language: string(),
    definitions: record(string()),
});
export type BaseDictionary = TypeOf<typeof BaseDictionary>;

/* ------------------------------- Dictionary ------------------------------- */

export const Dictionary = object({
    language: string(),
    definitions: record(string()).transform((arg) => ({
        // Strings are put here temporarily until the entry exists in the dictionary
        // Entries in the dictionary will override what is here so as soon as they become available they work
        // This also acts as a good list keeper to let the backend guys know what strings need to be added for a feature

        'subscription-page.tile.group-already-subscribed': 'You can not subscribe to more that one tier',

        ...arg,
    })),
});
export type Dictionary = TypeOf<typeof Dictionary>;
